var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-editor-button c-box flex-limit",class:{ 'active': _vm.active, 'disabled': _vm.disabled},style:({ width: _vm.width + 'px' }),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }